<template>
  <div>
    <a-tabs default-active-key="cpp" @change="handleTabChange">
      <a-tab-pane v-for="item in tabs" :key="item.key" :tab="item.label" />
    </a-tabs>
    <div class="mt-2">
      <keep-alive>
        <component
          ref="com"
          :is="currentTab"
          :resId="resId"
          :data="data"
          :getParams="getParams"
          :accountData="accountData" />
      </keep-alive>
    </div>
  </div>

</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import Cpp from './Cpp'
import CppShared from './CppShared'

export default {
  name: 'BillCppSharingForCloudaccountSidepage',
  components: {
    Cpp,
    CppShared,
  },
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    resId: String,
    data: Object,
    getParams: [Function, Object],
    accountData: Object,
  },
  data () {
    return {
      currentTab: 'cpp',
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { key: 'cpp', label: this.$t('bill.cpp') },
        { key: 'cpp-shared', label: this.$t('bill.cpp_shared') },
      ]
      return tabs
    },
  },
  methods: {
    handleTabChange (tab) {
      this.currentTab = tab
      setTimeout(() => {
        this.$refs.com.initTime()
      }, 0)
    },
  },
}
</script>
